<template>
  <div class="home-container">
    <main class="main-content">
      <SearchBox />

      <div class="featured-section">
        <h2>热门导师</h2>
        <div class="featured-grid">
          <div v-for="professor in featuredProfessors" :key="professor.id" class="professor-card">
            <h3>{{ professor.name }}</h3>
            <p>{{ professor.school_name }} · {{ professor.college_name }}</p>
            <router-link
                :to="{
                name: 'ProfessorDetail',
                params: { id: professor.id },
                query: {
                  name: professor.name,
                  school_name: professor.school_name,
                  college_name: professor.college_name
                }
              }"
                class="view-detail">
              查看详情
            </router-link>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import BlogFooter from '@/components/BlogFooter.vue'
import SearchBox from '@/components/SearchBox.vue'
import axios from "axios";
import {API_BASE_URL} from "@/config";

export default {
  name: 'HomeView',
  components: {
    BlogFooter,
    SearchBox
  },
  data() {
    return {
      featuredProfessors: []
    }
  },
  created() {
    this.fetchFeaturedProfessors()
  },
  methods: {
    async fetchFeaturedProfessors() {
      try {
        const response = await axios.get(`${API_BASE_URL}/professors/top`)
        if (response.data.code === 200 || response.data.code === 201) {
          this.featuredProfessors = response.data.data
        } else {
          console.error('获取热门导师失败，返回码非 200:', response.data)
        }

      }
      catch (error) {
        console.error('获取热门导师失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.home {
  padding: 0 2rem;
  background-color: #f8f9fa; /* 新增背景色 */
  min-height: 100vh; /* 确保背景覆盖整个页面 */
}

.home-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.featured-section {
  margin-top: 3rem;
}

.featured-section h2 {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 2rem;
}

.featured-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
}

.professor-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.professor-card:hover {
  transform: translateY(-5px);
}

.professor-card h3 {
  margin-top: 0;
  color: #3498db;
}

.rating {
  color: #f39c12;
  font-weight: bold;
  margin-top: 0.5rem;
}

.stars {
  letter-spacing: 2px;
}
</style>